import { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppIcon } from "./BrandIcons";
import { waLink } from "@/lib/site";

const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    aria-label="Chat with us on WhatsApp"
    data-testid="whatsapp-floating-button"
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:scale-110 md:bottom-7 md:right-7"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20" />
    <WhatsAppIcon className="relative h-7 w-7" />
  </a>
);

const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(!localStorage.getItem("at_cookie_consent"));
  }, []);
  const choose = (v) => {
    localStorage.setItem("at_cookie_consent", v);
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 md:inset-x-auto md:bottom-6 md:left-6 md:max-w-md" data-testid="cookie-banner">
      <div className="card-soft border border-slate-200 bg-white/95 p-5 shadow-2xl backdrop-blur-xl">
        <p className="text-sm leading-relaxed text-slate-600">
          We use essential cookies to make this site work, and optional cookies to understand how it is used.{" "}
          <Link to="/privacy" className="text-ink underline decoration-gold underline-offset-4">Privacy Policy</Link>
        </p>
        <div className="mt-4 flex gap-2">
          <button onClick={() => choose("all")} className="btn btn-dark min-h-[42px] flex-1 px-4" data-testid="cookie-accept-button">Accept</button>
          <button onClick={() => choose("essential")} className="btn btn-outline min-h-[42px] flex-1 px-4" data-testid="cookie-essential-button">Essential only</button>
        </div>
      </div>
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <div className="min-h-screen bg-white">
    <ScrollToTop />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <WhatsAppFloat />
    <CookieBanner />
  </div>
);
